module.exports = __webpack_public_path__ + "static/media/034-china.ce0184f1.svg";